(() => {
  function formatContent(section) {
    section.querySelectorAll('[data-ae-page-content]:not([data-ae-formatted])').forEach(content => {
      content.dataset.aeFormatted = 'true';
      content.querySelectorAll('h1').forEach(h => { if (!h.textContent.trim()) h.remove(); });
      content.querySelectorAll(':scope > .rte').forEach(w => w.replaceWith(...w.childNodes));
      if (!content.querySelector(':scope > br')) return;
      const groups = []; let group = []; let breaks = 0;
      [...content.childNodes].forEach(node => {
        if (node.nodeName === 'BR') {
          breaks++;
          if (breaks === 1) group.push(node);
          if (breaks === 2) { group.pop(); if (group.length) groups.push(group); group = []; }
        } else if (node.nodeType === 3 && !node.textContent.trim() && breaks) { return; }
        else { breaks = 0; group.push(node); }
      });
      if (group.length) groups.push(group);
      const fragment = document.createDocumentFragment();
      groups.forEach(nodes => {
        const text = nodes.map(n => n.textContent).join('').trim(); if (!text) return;
        const block = nodes.some(n => n.nodeType === 1 && n.matches('p,div,ul,ol,table,h2,h3,blockquote'));
        const heading = !block && text.length < 150 && /[A-ZÀ-Ü]/.test(text) && text === text.toUpperCase();
        const el = document.createElement(/^[-–—\s]+$/.test(text) ? 'hr' : heading ? 'h2' : block ? 'div' : 'p');
        if (el.tagName !== 'HR') nodes.forEach(n => el.appendChild(n));
        fragment.appendChild(el);
      });
      content.replaceChildren(fragment);
    });
  }
  function initialize(section = document) {
    formatContent(section);
    section.querySelectorAll('[data-ae-preview-hint]').forEach(hint => {
      const root = hint.closest('product-info'); if (!root || root.aeRefinementCleanup) return;
      const scope = root.closest('section') || root;
      const media = scope.querySelector('media-gallery');
      const link = hint.querySelector('[data-ae-preview-link]');
      if (media?.id && link) link.href = `#${media.id}`;
      let interacted = false; let frame = 0;
      const preview = () => [...(media?.querySelectorAll('.pplr_preview_wrapper') || [])].find(el => {
        const rect = el.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && getComputedStyle(el).visibility !== 'hidden' && getComputedStyle(el).opacity !== '0' && el.querySelector('canvas,img');
      });
      const onPreview = event => {
        if (!preview()) return;
        event.preventDefault();
        media.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
      };
      const update = () => {
        frame = 0;
        const personalizer = root.querySelector('.product-personalizer'); if (!personalizer) return;
        const photo = personalizer.querySelector('.cp-sel-Photos:not(.p_h_d_p)');
        if (photo && photo.nextElementSibling !== hint) photo.after(hint);
        hint.hidden = !interacted || !preview();
        personalizer.querySelectorAll('select.pplr_select').forEach(select => {
          const label = select.closest('.pplr-wrapper')?.querySelector('.parfumtitle'); if (!label) return;
          if (!select.hasAttribute('aria-label')) select.setAttribute('aria-label',label.textContent.trim());
          [...select.options].forEach(option => {
            if (/^[-–—\s]*select[-–—\s]*$/i.test(option.textContent.trim())) {
              option.textContent = hint.dataset.fragrancePlaceholder; option.hidden = true; option.disabled = true;
            }
          });
        });
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      const onInteraction = event => {
        const t = event.target;
        if (!event.isTrusted || !t.closest('.product-personalizer')) return;
        if (event.type === 'click' && t.closest('.pplr-swatch-element,select.pplr_select')) interacted = true;
        if (event.type === 'change' && (t.matches('select.pplr_select') || (t.matches('input[type=file]') && t.files?.length))) interacted = true;
        schedule();
      };
      link?.addEventListener('click',onPreview);
      root.addEventListener('click',onInteraction,true); root.addEventListener('change',onInteraction,true);
      const observer = new MutationObserver(schedule);
      observer.observe(scope,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style','src','width','height']});
      root.aeRefinementCleanup = () => {
        observer.disconnect(); cancelAnimationFrame(frame); link?.removeEventListener('click',onPreview);
        root.removeEventListener('click',onInteraction,true); root.removeEventListener('change',onInteraction,true); delete root.aeRefinementCleanup;
      };
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => initialize(),{once:true}); else initialize();
  document.addEventListener('shopify:section:load',e => initialize(e.target));
  document.addEventListener('shopify:section:unload',e => e.target.querySelectorAll('product-info').forEach(r => r.aeRefinementCleanup?.()));
})();
